module.exports = __webpack_public_path__ + "img/schysst_elhandel@3x.a2f0dcbb.jpg";